import { Component, OnInit } from '@angular/core';
import {InfoApiService} from '../../../services/rest-api/info.api.service';
import {ActivatedRoute, Router} from '@angular/router';
import {HssResponse} from '../../../services/rest-api/HssResponse';
import {HssErrorResponse} from '../../../services/rest-api/HssErrorResponse';
import {StorageService} from '../../../services/rest-api/storage.service';

@Component({
  selector: 'app-dept-header',
  templateUrl: './dept-header.component.html',
  styleUrls: ['./dept-header.component.scss']
})
export class DeptHeaderComponent implements OnInit {
  linksData: any;
  deptData: any[] = [];
  countData: any[] = [];
  private deptId: any = 0;

  constructor(private _info: InfoApiService,
              private _actRoute: ActivatedRoute,
              private router: Router,
              private storage: StorageService) {

    this._actRoute.paramMap.subscribe(params => {
      this.deptId = this._actRoute.snapshot.params.id;
      this.loadData();
      // get selected degree from local storage

    });
  }

  ngOnInit(): void {
    this.loadData();
  }

  loadData(){
    // this.linksData = [];

    if(this.deptId == null){
      this.deptId = localStorage.getItem('currentDeptId');
    }

    this.getCountsByDeptId(this.deptId);
    this.getDepartmentById(this.deptId);
    this.getLinksByDept(this.deptId);
  }

  getLinks(links: any){
    this.linksData = links;
  }

  navigatePage(current: string, param?: any) {
    if (current === 'dept_home') {
      this.router.navigate(['/department/'+param.code+'/'+param.id]);
    } else if (current === 'degrees') {
      this.router.navigate(['/degrees/'+param]);
    }else if (current === 'faq') {
      this.router.navigate(['/faq/'+param]);
    }else if (current === 'deptstaff') {
      this.router.navigate(['/deptstaff/'+param]);
    }
  }

  // Get departments
  getDepartmentById(deptId: number){
    this._info.getDepartmentById(deptId).subscribe (
      (response: HssResponse<any>) => {
        this.deptData = response.body;

      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;

      }
    );
  }

  // Get departments
  getCountsByDeptId(deptId: number){
    this._info.getCountsByDeptId(deptId).subscribe (
      (response: HssResponse<any>) => {
        this.countData = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  // View degrees by department id
  getLinksByDept(deptId: number){
    this.linksData = [];
    this._info.getLinksByDept(deptId).subscribe (
      (response: HssResponse<any>) => {
        this.linksData = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

}
